/*
	HeaderProfile.tsx -- The profile/avatar component of the header bar.
*/
import { useContext } from 'react';

import { DropdownItem, DropdownItemClickType, TextDropdownButton } from 'Components/Buttons/DropdownButton';
import { RBACContext, Role, userHasAuthorizedRole } from 'Components/Context/RBACContext';
import { SETTINGS } from 'Config/PathTemplates';

export interface HeaderProfileProps {
    username: string;
    handleChangePasswordClick: () => void;
    handleLogout: () => void;
    handleReleaseNotesClick: () => void;
    handleSupportClick: () => void;
    handleUserManualClick: () => void;
}

export const HeaderProfile = (props: HeaderProfileProps) => {
    const rbacContext = useContext(RBACContext);

    const generateHeaderProfileDropdownItems = (): DropdownItem[] => {
        const headerProfileDropdownItems: DropdownItem[] = [];

        // Ensure only Administrators have access to settings.
        if (rbacContext && userHasAuthorizedRole(rbacContext.roles, [Role.ADMIN])) {
            headerProfileDropdownItems.push({
                _type: DropdownItemClickType.HYPERLINK,
                text: 'Settings',
                href: SETTINGS,
            });
        }

        headerProfileDropdownItems.push(
            {
                _type: DropdownItemClickType.ONCLICK,
                text: 'Change Password',
                onClick: () => props.handleChangePasswordClick(),
            },
            {
                _type: DropdownItemClickType.ONCLICK,
                text: 'User Manual',
                onClick: () => props.handleUserManualClick(),
            },
            {
                _type: DropdownItemClickType.ONCLICK,
                text: 'Release Notes',
                onClick: () => props.handleReleaseNotesClick(),
            },
            {
                _type: DropdownItemClickType.ONCLICK,
                text: 'Contact Support',
                onClick: () => props.handleSupportClick(),
            },
            {
                _type: DropdownItemClickType.ONCLICK,
                text: 'Log Out',
                onClick: () => props.handleLogout(),
            }
        );

        return headerProfileDropdownItems;
    };

    return <TextDropdownButton dropdownItems={generateHeaderProfileDropdownItems()} text={props.username} />;
};
